import axios from 'axios'

async function get_results_all(email,setResults,token,setLoading){

try{

  const data = {
    email:email
  }

  setLoading(true)

  const getResults = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-results-all/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

  if (getResults?.status == 200 && getResults?.data.success == true) {
  
    setResults(getResults?.data.results)
  }else{
    console.log(getResults?.data.message)
  }
  setLoading(false)
}catch(err){
  console.log(err)
}
}

export default get_results_all